module.exports = __webpack_public_path__ + "img/powered-by-refera.c5e5c22a.svg";